<div class="modal-header">
  <h4 class="modal-title">{{ titulo }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="card-body">
    <div class="col-md-12">
      <form
        action=""
        [formGroup]="unityForm"
        (ngSubmit)="registerUnitys()"
        class="form-horizontal form-material"
        id="productform"
        novalidate
      >
        <div class="form-group row  m-t-20">
          <div class="col-xs-12 col-md-6">
            <app-form-error-wrapper
              [control]="unityForm.controls['nombre']"
              [controlName]="'Nombre'"
            >
              <label for="nombre">Nombre del Producto</label>
              <input
                class="form-control"
                type="text"
                id="nombre"
                formControlName="nombre"
                placeholder="Nombre de producto"
              />
            </app-form-error-wrapper>
          </div>
          <div class="col-xs-12 col-md-6">
            <app-form-error-wrapper
              [control]="unityForm.controls['abreviado']"
              [controlName]="'Abreviacion'"
            >
              <label for="abre">Abreviación</label>
              <input
                class="form-control"
                type="text"
                id="abre"
                formControlName="abreviado"
                placeholder="Abreviacion "
              />
            </app-form-error-wrapper>
          </div>
        </div>
        <div class="form-group text-center m-t-20">
          <div class="col-xs-12">
            <button
              class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
              [disabled]="unityForm.invalid || isLoading"
            >
              <app-button-loader
                [isLoading]="isLoading"
                [label]="'GUARDAR'"
              ></app-button-loader>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
